import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'antd';

import DownloadTable from 'components/download-table';

import columns from './columns';
import './style.css';

const EmployersWidget = ({ users, organizations }) => {
  const data = users
    .filter((user) => user.info.role === 'isEmployer')
    .map((user) => {
      if (!user.organization) return user;
      const org = organizations.find((item) => item.id === user.organization);
      if (!org) return user;
      return {
        ...user,
        organization: org,
      };
    });

  return (
    <section className="admin-panel-section">
      <header className="admin-panel-header">
        <h2>Employers</h2>
        <DownloadTable data={data} columns={columns} name="employers" />
      </header>
      <Table dataSource={data} columns={columns} />
    </section>
  );
};

EmployersWidget.propTypes = {
  users: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
    })
  ).isRequired,
  organizations: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
    })
  ).isRequired,
};

export default EmployersWidget;
